import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { tagStyle } from "@/lib/tags";

const THEME_BG = {
  pink: "bg-[var(--tint-red)]",
  mint: "bg-[var(--tint-milk)]",
  lavender: "bg-[var(--tint-wine)]",
  yellow: "bg-[var(--tint-copper)]",
};

export const RelatedPosts = ({ currentSlug, tags }) => {
  const [related, setRelated] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/posts")
      .then((r) => {
        if (cancelled) return;
        const current = (tags || []).map((t) => t.toLowerCase());
        const scored = r.data
          .filter((p) => p.slug !== currentSlug)
          .map((p) => ({
            p,
            score: (p.tags || []).filter((t) => current.includes(t.toLowerCase())).length,
          }))
          .sort((a, b) => b.score - a.score || new Date(b.p.created_at) - new Date(a.p.created_at));
        setRelated(scored.slice(0, 3).map((x) => x.p));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [currentSlug, tags]);

  if (related.length === 0) return null;

  return (
    <section className="mx-auto max-w-4xl px-6 pb-4" data-testid="related-posts">
      <p className="text-xs uppercase tracking-[0.3em] text-[var(--accent)]">Îți mai recomand</p>
      <h3 className="mt-2 font-serif text-2xl font-medium text-[#F7F1E8]">Însemnări asemănătoare</h3>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {related.map((p) => (
          <Link
            key={p.id}
            to={`/post/${p.slug}`}
            data-testid={`related-post-${p.slug}`}
            className={`group rounded-2xl ${THEME_BG[p.color_theme] || THEME_BG.pink} p-5 ring-1 ring-[color-mix(in_srgb,var(--milk)_18%,transparent)] transition-transform hover:-translate-y-1`}
          >
            <p className="font-serif text-lg leading-snug text-[#F7F1E8] group-hover:underline group-hover:underline-offset-4">
              {p.title}
            </p>
            {p.tags && p.tags.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-1.5">
                {p.tags.slice(0, 2).map((t) => (
                  <span key={t} className={`rounded-full px-2.5 py-0.5 text-[10px] font-medium ${tagStyle(t)} ring-1 ring-[color-mix(in_srgb,var(--milk)_18%,transparent)]`}>
                    {t}
                  </span>
                ))}
              </div>
            )}
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;
